/**
 * The product's name, drawn once. The capabilities catalogue and its example pages name the
 * product in prose; a string typed in three places is a string that goes stale in one of them.
 * Modelled on t4's, so the suite has one way of writing its own name.
 */
import React from "react";
import {Box} from "@mui/material";

import {Blue3, Blue4, Grey5} from "../theme/styles";

export const PRODUCT = "Parkour-AI · eTMF";

const [FIRST, SECOND] = PRODUCT.split(" · ");

export function ProductName({bold = false}: {bold?: boolean} = {}) {
    return (
        <Box component="span" sx={{whiteSpace: "nowrap", fontWeight: bold ? 600 : "inherit"}}>
            <Box component="span" sx={{color: Blue4}}>{FIRST}</Box>
            <Box component="span" sx={{color: Grey5}}>{" · "}</Box>
            <Box component="span" sx={{color: Blue3}}>{SECOND}</Box>
        </Box>
    );
}

export function productName(text: string): React.ReactNode[] {
    return text.split(PRODUCT).flatMap((part, i) =>
        i === 0 ? [part] : [<ProductName key={i}/>, part]);
}
